import React, {Component} from 'react';
import {func, node, string} from 'prop-types';
import SmallButton from '../SmallButton';
import styles from './ConfirmModal.scss';
import {default as Dialog} from '@sinclair-digital/sbg-storyline-components/src/components/Dialog';

/**
 * @typedef {object} ConfirmModalProps
 * @prop {function} [onCancel]
 * @prop {function} [onConfirm]
 * @prop {React.ReactNode} [children]
 * @prop {string} [headerText]
 * @prop {string} [cancelText]
 * @prop {string} [confirmText]
 *
 * @extends Component<ConfirmModalProps>
 */
class ConfirmModal extends Component {
    static propTypes = {
        onCancel: func,
        onConfirm: func,
        children: node,
        headerText: string,
        cancelText: string,
        confirmText: string,
    };

    static defaultProps = {
        onCancel: () => {},
        onConfirm: () => {},
        children: null,
        headerText: 'Confirm',
        cancelText: 'Cancel',
        confirmText: 'Confirm',
    };

    /* istanbul ignore next */
    render() {
        const {headerText, cancelText, confirmText, children, onCancel, onConfirm} = this.props;
        return (
            <Dialog isOpen={true} className={styles.modal} contentLabel={headerText}>
                <div className={styles.header}>
                    <div className={styles.close} onClick={onCancel}>
                        ×
                    </div>
                    <div className={styles.headerMessage}>
                        <h3 className={styles.headerText}>{headerText}</h3>
                    </div>
                </div>
                <div className={styles.bodyText}>{children}</div>
                <div className={styles.footer}>
                    <div className={styles.buttons}>
                        <div className={styles.footerButton}>
                            <SmallButton color="highlight" onClick={onConfirm}>
                                {confirmText}
                            </SmallButton>
                        </div>
                        <div className={styles.footerButton}>
                            <SmallButton onClick={onCancel}>{cancelText}</SmallButton>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default ConfirmModal;
